import { Grid } from '@mui/material';
import { dateFormat } from '@nx-smartmonkey/shared/helpers';
import { RoutalPalette, RoutalTooltip } from '@nx-smartmonkey/ui';

import More3Points from '../../../../assets/svg/More3Points';
import { SupervisorsTableColumn } from '../../../../context/supervisor/tableColumns';
import Text from '../../../../react-components/Text';
import { AlignmentTypes, DataTableColumnProps } from '../../../../react-components/data-table/DataTable';
import { SupervisorsActionsMenu } from './SupervisorsActionsMenu';

type SupervisorsGetColumnsResponse = { [key: string]: any }[];

type SupervisorsGetColumns = {
  tableColumns: Array<SupervisorsTableColumn>;
};

export const getSupervisorsColumns = ({ tableColumns }: SupervisorsGetColumns): SupervisorsGetColumnsResponse => {
  const columns: Array<DataTableColumnProps> = [];

  tableColumns.forEach(({ displayable, identifier, sortable }: SupervisorsTableColumn) => {
    if (displayable) {
      switch (identifier) {
        case `email`:
          columns.push({
            width: 220,
            accessorName: identifier,
            align: `center` as AlignmentTypes,
            name: (
              <Text
                style={{ color: RoutalPalette.primary20 }}
                isBold
                intlId={`supervisors.data.details.${identifier}`}
              />
            ),
            sortable,
          });
          break;
        case `short_id`:
        case `name`:
        case `company`:
          columns.push({
            width: 250,
            accessorName: identifier,
            sortable,
            name: (
              <Text
                isBold
                style={{ color: RoutalPalette.primary20 }}
                intlId={`supervisors.data.details.${identifier}`}
              />
            ),
            formatter: ({ value }) => (
              <Grid container direction="row" alignItems="center">
                {value && value !== `` ? (
                  <RoutalTooltip title={value} key="label">
                    <Text variant="body">{value.length > 30 ? `${value.substring(0, 30)}...` : `${value}`}</Text>
                  </RoutalTooltip>
                ) : (
                  <Text variant="body" style={{ color: RoutalPalette.secondary00 }} intlId="no_name" />
                )}
              </Grid>
            ),
          });
          break;
        // case language:
        //   break;
        case `created_at`:
          break;
        default:
          break;
      }
    }
  });

  return [
    ...columns,
    ...(tableColumns.find(({ displayable, identifier }) => identifier === `created_at` && displayable)
      ? [
          {
            width: 130,
            accessorName: `created_at`,
            align: `center` as AlignmentTypes,
            sortable: true,
            name: (
              <Text style={{ color: RoutalPalette.primary20 }} isBold intlId="supervisors.data.details.created_at" />
            ),
            formatter: ({ value: createdAt }) => <Text variant="body">{dateFormat(createdAt)}</Text>,
          } as DataTableColumnProps,
        ]
      : []),
    {
      align: `right`,
      width: 100,
      flex: 1,
      formatter: ({ doc: supervisor, rowHover }) => (
        <Grid container justifyContent="flex-end">
          {rowHover ? (
            <SupervisorsActionsMenu
              type="popover"
              supervisors={[supervisor]}
              popoverProps={{
                hideArrow: true,
                content: <More3Points />,
                style: { height: `18px`, color: RoutalPalette.secondary60, padding: 0, margin: 0, border: `unset` },
              }}
            />
          ) : null}
        </Grid>
      ),
    },
  ] as Array<DataTableColumnProps>;
};
